export const RESET_PAGINATION = {
    count: 0,
    offset: 0,
    limit: 10,
};

export const GET_ALL_PAGINATION = {
    count: 0,
    offset: 0,
    limit: 1000,
}

export const ASC = "asc";
export const DESC = "desc";
export const NO_DATA_AVAILABLE = "No data available!";

export const TOAST_MESSAGES = {
    FAILED_lOAD: "Failed to load data!",
    DATA_FETCHED: "Data fetched successfully!",
    EXCEL_DOWNLOAD_FAILED: "Failed to download Excel file. Please try again later.",
    EXCEL_DOWNLOAD_SUCCESS: "Excel file downloaded successfully.",
    EXCEL_MOBILE_DOWNLOAD_SUCCESS: "Excel file saved to device.",
    SESSION_TIMEOUT: "Session Timeout"
}

export const ROLES = {
    ADMIN_ROLE: "admin",
    PROJECT_INCHARGE: "project_incharge",
    SITE_STAFF: "site staff",
    INCHARGE: "incharge",
    HR: "HR",
    DIRECTOR_MANAGEMENT: "director_management",
    ACCOUNTS_ROLE: "accounts",
}

export const TASK_STATUS = {
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS",
    PENDING_L1_APPROVAL: "PENDING_L1_APPROVAL",
    PENDING_L2_APPROVAL: "PENDING_L2_APPROVAL",
    COMPLETED: "COMPLETED"
}

export const MANAGE = "Manage";

export const USER_ROLES = {
    ADMIN: "ADMIN",
    PROJECT_INCHARGE: "PROJECT_INCHARGE",
    SITE_STAFF: "SITESTAFF",
    INCHARGE: "INCHARGE",
    HR: "HR",
    DIRECTOR_MANAGEMENT: "DIRECTOR_MANAGEMENT",
    ACCOUNTS: "ACCOUNTS",
}